export const SUPPORTED_PRACTICE_AREAS = ['Primary Care'] as const;

export type SupportedPracticeArea = (typeof SUPPORTED_PRACTICE_AREAS)[number];

export function normalizePracticeArea(value: string): string {
  return value.trim().toLowerCase();
}

export function toSupportedPracticeArea(value: string): SupportedPracticeArea | null {
  const normalized = normalizePracticeArea(value);
  const match = SUPPORTED_PRACTICE_AREAS.find(
    (practiceArea) => normalizePracticeArea(practiceArea) === normalized
  );
  return match ?? null;
}
